import { getBFFApiClient } from '@acp/feature/auth';
import {
    AddressCreationParts, AddressCreationResponse, AddressMeta,
    AddressSearchQuery, AddressSearchResponse, APIResponse, DIAddressParts, SuburbSearchResult,
} from '@acp/shared';
import { GenericAbortSignal } from 'axios';
import HttpStatusCodes from 'http-status-codes';

async function searchSuburbs(query: string) {
    const response = await getBFFApiClient().get<APIResponse<SuburbSearchResult[]>>(
        '/v1/meta/suburbs',
        {
            params: {
                q: query,
            },
        }
    );

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error('Failed to search suburbs');
    }

    return response.data.data;
}

async function searchAddress(
    addressSearchQuery: AddressSearchQuery,
    abortSignal?: GenericAbortSignal
) {
    const response = await getBFFApiClient().get<APIResponse<AddressSearchResponse[]>>('/v1/address/search', {
        params: addressSearchQuery,
        signal: abortSignal,
    });

    if (response.data.success === false) {
        throw new Error(`Error searching address: ${response.data.error}`);
    }

    return response.data.data;
}

async function getAddressParts(address: string) {
    const response = await getBFFApiClient().get<APIResponse<DIAddressParts>>('/v1/address/parts', {
        params: {
            address,
        },
    });

    if (response.data.success === false) {
        throw new Error(`Error getting address parts: ${response.data.error}`);
    }

    return response.data.data;
}

async function createAddress(addressData: AddressCreationParts) {
    const response = await getBFFApiClient().post<APIResponse<AddressCreationResponse>>('/v1/address', addressData);

    if (response.data.success === false) {
        throw new Error(`Error creating address: ${response.data.error}`);
    }

    return response.data.data;
}

export async function getAddressById(addressId: number) {
    const response = await getBFFApiClient().get<APIResponse<AddressMeta>>(`/v1/address/${addressId}`);

    if (response.data.success === false) {
        throw new Error(`Error fetching address details: ${response.data.error}`);
    }

    return response.data.data;
}

export {
    searchSuburbs, createAddress, searchAddress, getAddressParts,
};
